import axios from 'axios'
import { getApiToken } from './wireApiClient'

export const articlesApiClient = axios.create({
  baseURL: import.meta.env.VITE_ARTICLES_API_URL ?? 'https://articles-api-rewire.com',
  headers: { 'Content-Type': 'application/json' },
})

articlesApiClient.interceptors.request.use((config) => {
  const token = getApiToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
